const fonts = {
  family: {
    primary: 'Inter, sans-serif',
    secondary: 'Inter',
  },
  weight: {
    regular: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
    extraBold: 800,
  },
  sizes: {
    xxSmall: '0.625rem',
    xSmall: '0.75rem',
    small: '0.875rem',
    medium: '1rem',
    large: '1.125rem',
    xLarge: '1.25rem',

    '2xlarge': '1.5rem',
    '3xlarge': '1.75rem',
    '4xlarge': '2rem',
    '5xlarge': '2.25rem',
    '6xlarge': '2.375rem',
  },
}

export default fonts
